import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledSpan = styled('span')`
  margin: 0 8px;
  padding: 8px 16px;
  background: ${colours.Greyscale.White};
  color: black;
  font-weight: 400;
`;
